import * as HLF from "html-living-framework";
import * as Constants from "../Data/Constants";
import * as QuiltUtils from "../Utils/QuiltUtils";

export class QuiltFrame extends PIXI.Container {
    constructor() {
        super();

        const sheet: string = Constants.SPRITESHEET_QUILT_PREFIX + "01";

        const center: PIXI.Sprite = HLF.PixiUtils.makeSprite("bg-center", sheet);
        this.addChild(center);

        const top: PIXI.Sprite = HLF.PixiUtils.makeSprite("bg-top", sheet);
        top.anchor.set(0.5, 1);
        this.addChild(top);

        const bottom: PIXI.Sprite = HLF.PixiUtils.makeSprite("bg-bottom", sheet);
        bottom.anchor.set(0.5, 0);
        this.addChild(bottom);

        const left: PIXI.Sprite = HLF.PixiUtils.makeSprite("bg-left", sheet);
        left.anchor.set(1, 0.5);
        this.addChild(left);

        const right: PIXI.Sprite = HLF.PixiUtils.makeSprite("bg-right", sheet);
        right.anchor.set(0, 0.5);
        this.addChild(right);

        top.y = -left.height * 0.5 + top.height;
        bottom.y = -top.y;
        left.x = -top.width * 0.5;
        right.x = -left.x;
        center.width = top.width;
        center.height = left.height - top.height - bottom.height;

        for (let x = 0; x < QuiltUtils.GRID_SIZE.x; ++x) {
            for (let y = 0; y < QuiltUtils.GRID_SIZE.y; ++y) {
                const suffix: number = (x + y) % 2;
                const tile: PIXI.Sprite = HLF.PixiUtils.makeSprite("empty-0" + suffix, sheet);
                tile.anchor.set(0, 0);
                tile.width = QuiltUtils.TILE_WIDTH;
                tile.height = tile.width;
                tile.position.set(
                    (x - (QuiltUtils.GRID_SIZE.x * 0.5)) * QuiltUtils.TILE_WIDTH,
                    (y - (QuiltUtils.GRID_SIZE.x * 0.5)) * QuiltUtils.TILE_WIDTH,
                );
                this.addChild(tile);
            }
        }
    }
}
